import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const CARDINALITIES = [
  { value: 'one-to-one', label: 'One-to-One' },
  { value: 'one-to-many', label: 'One-to-Many' },
  { value: 'many-to-many', label: 'Many-to-Many' },
];

const RelationFormDialog = ({ open, initial, classes, onCancel, onSubmit }) => {
  const [form, setForm] = useState({
    relation_id: initial.relation_id,
    name: initial.name || '',
    inverse_name: initial.inverse_name || '',
    description: initial.description || '',
    domain_class_ids: initial.domain_class_ids || [],
    range_class_ids: initial.range_class_ids || [],
    cardinality: initial.cardinality || 'many-to-many',
    is_hierarchical: !!initial.is_hierarchical,
  });
  const toggle = (list, id) => list.includes(id) ? list.filter(x => x !== id) : [...list, id];
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="max-w-xl">
        <DialogHeader><DialogTitle>{form.relation_id ? 'Edit Relation' : 'New Relation'}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="text-xs">Name * (camelCase)</Label>
              <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="implements" data-testid="relation-name-input" />
            </div>
            <div>
              <Label className="text-xs">Inverse name (optional)</Label>
              <Input value={form.inverse_name} onChange={(e) => setForm({ ...form, inverse_name: e.target.value })} placeholder="implementedBy" />
            </div>
          </div>
          <div>
            <Label className="text-xs">Description</Label>
            <Textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} rows={2} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="text-xs">Domain (subject classes)</Label>
              <div className="max-h-[120px] overflow-y-auto border border-[#E5E7EB] rounded p-1.5 space-y-0.5">
                {classes.map(c => (
                  <label key={c.class_id} className="flex items-center gap-1.5 text-xs cursor-pointer">
                    <input type="checkbox" checked={form.domain_class_ids.includes(c.class_id)} onChange={() => setForm({ ...form, domain_class_ids: toggle(form.domain_class_ids, c.class_id) })} />
                    {c.name}
                  </label>
                ))}
              </div>
            </div>
            <div>
              <Label className="text-xs">Range (object classes)</Label>
              <div className="max-h-[120px] overflow-y-auto border border-[#E5E7EB] rounded p-1.5 space-y-0.5">
                {classes.map(c => (
                  <label key={c.class_id} className="flex items-center gap-1.5 text-xs cursor-pointer">
                    <input type="checkbox" checked={form.range_class_ids.includes(c.class_id)} onChange={() => setForm({ ...form, range_class_ids: toggle(form.range_class_ids, c.class_id) })} />
                    {c.name}
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div>
            <Label className="text-xs">Cardinality</Label>
            <Select value={form.cardinality} onValueChange={(v) => setForm({ ...form, cardinality: v })}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>{CARDINALITIES.map(c => <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>Cancel</Button>
          <Button className="bg-[#002FA7] hover:bg-[#001F6F]" onClick={() => onSubmit(form)} disabled={!form.name.trim()} data-testid="submit-relation">Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RelationFormDialog;
